module.exports = __webpack_public_path__ + "static/img/icon-NZL.e9d11af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-NZL.svg
// module id = 8DJG
// module chunks = 0